import { Controller } from "@hotwired/stimulus"

// Copies text to clipboard with visual feedback
// Usage:
//   <div data-controller="clipboard">
//     <input data-clipboard-target="source" value="text to copy">
//     <button data-action="click->clipboard#copy" data-clipboard-success-text="Copied!">Copy</button>
//   </div>
//
// For custom URL builder:
//   <div data-controller="clipboard">
//     <input data-clipboard-target="customSource" placeholder="source">
//     <input data-clipboard-target="customMedium" placeholder="medium">
//     <input type="hidden" data-clipboard-target="source" data-base-url="https://...">
//     <button data-action="click->clipboard#copyCustom">Copy Link</button>
//   </div>
export default class extends Controller {
  static targets = ["source", "customSource", "customMedium", "label"]
  static values = {
    successDuration: { type: Number, default: 2000 }
  }

  copy(event) {
    const button = event.currentTarget
    const text = this.sourceTarget.value

    navigator.clipboard.writeText(text).then(() => {
      this.showSuccess(button)
    }).catch(err => {
      console.error('Failed to copy:', err)
    })
  }

  copyCustom(event) {
    const button = event.currentTarget
    const baseUrl = this.sourceTarget.dataset.baseUrl || this.sourceTarget.value
    const source = this.hasCustomSourceTarget ? this.customSourceTarget.value.trim() : ''
    const medium = this.hasCustomMediumTarget ? this.customMediumTarget.value.trim() : ''

    if (!source) {
      // Flash the source input to indicate it's required
      this.customSourceTarget.classList.add('ring-2', 'ring-red-500')
      setTimeout(() => {
        this.customSourceTarget.classList.remove('ring-2', 'ring-red-500')
      }, 1000)
      return
    }

    // Build the URL with UTM params
    const url = new URL(baseUrl)
    url.searchParams.set('utm_source', source.toLowerCase().replace(/\s+/g, '_'))
    if (medium) {
      url.searchParams.set('utm_medium', medium.toLowerCase().replace(/\s+/g, '_'))
    }

    navigator.clipboard.writeText(url.toString()).then(() => {
      this.showSuccess(button)
    }).catch(err => {
      console.error('Failed to copy:', err)
    })
  }

  showSuccess(button) {
    const originalContent = button.innerHTML
    const successText = button.dataset.clipboardSuccessText || "Copied!"
    const successIcon = button.dataset.clipboardSuccessIcon

    if (successIcon) {
      button.innerHTML = successIcon
    } else {
      button.textContent = successText
    }

    setTimeout(() => {
      button.innerHTML = originalContent
    }, this.successDurationValue)
  }
}
